import React, { type ReactNode } from 'react'

import Empty from '../../img/AfricanEmptyState.svg?react'

import './styles.sass'

type Props = {
	children: ReactNode
}

export default function DefaultErrorComponent(props: Props): React.ReactNode {
	return (
		<div className='DefaultErrorComponent'>
			<Empty />
			<div className='DefaultErrorComponent__Children'>{props.children}</div>
		</div>
	)
}
